import React from 'react';
import CTASection from '../components/CTASection';
import InteractiveMarketMap from '../components/InteractiveMarketMap';
import Reveal from '../components/Reveal';
import { buyerSupport, buyerTypes, markets } from '../data/siteData';

const GlobalPage = () => {
  return (
    <main>
      <section className="page-heading">
        <div className="container-custom">
          <Reveal>
            <p className="eyebrow-pill mb-5">Global reach</p>
            <h1 className="page-title">Export-ready coconut supply for international buyer networks.</h1>
            <p className="page-intro">
              S4CoconutExports supports trade conversations across import markets with product clarity, route-aware packaging discussion, documentation readiness, and responsive commercial communication.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="page-section">
        <div className="container-custom">
          <Reveal>
            <div className="map-section-intro">
              <p className="eyebrow-pill mb-5">Interactive market map</p>
              <h2>Country-level trade signals for coconut export planning.</h2>
              <p>
                Explore representative destination markets and the kind of buyer conversations S4CoconutExports supports across each region.
              </p>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <InteractiveMarketMap />
          </Reveal>
        </div>
      </section>

      <section className="page-section section-rule">
        <div className="container-custom">
          <div className="market-list market-list-compact">
            {markets.map((market, index) => (
              <Reveal key={market.name} delay={index * 90}>
                <article>
                  <span>{String(index + 1).padStart(2, '0')}</span>
                  <h2>{market.name}</h2>
                  <p>{market.text}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="page-section section-rule">
        <div className="container-custom">
          <div className="editorial-split">
            <Reveal>
              <div>
                <p className="eyebrow-pill mb-5">Buyer types served</p>
                <h2 className="section-title mb-5">Built for importers, distributors, retail channels, and food businesses.</h2>
                <p className="section-subtitle max-w-xl">
                  Whether the inquiry is for fresh coconut supply, processing material, retail movement, or ingredient use, the conversation is organized around product fit, packing, volume, and shipment planning.
                </p>
              </div>
            </Reveal>

            <Reveal delay={120}>
              <div className="buyer-type-grid">
                {buyerTypes.map((buyer) => (
                  <span key={buyer}>{buyer}</span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="page-section section-rule">
        <div className="container-custom">
          <Reveal>
            <div className="support-ledger">
              <div>
                <p className="eyebrow-pill mb-5">How we support buyers</p>
                <h2>Trade communication that respects your buying process.</h2>
              </div>
              <div>
                {buyerSupport.map((item, index) => (
                  <article key={item}>
                    <span>{String(index + 1).padStart(2, '0')}</span>
                    <p>{item}</p>
                  </article>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CTASection
        eyebrow="International inquiry"
        title="Planning coconut imports for your market?"
        text="Send product interest, country, target quantity, and preferred packaging so the team can respond with practical export guidance."
        primaryLabel="Send Global Inquiry"
        secondaryLabel="Review Process"
        secondaryPath="/process"
      />
    </main>
  );
};

export default GlobalPage;
